<template>
 <v-app>
  <div id="app">
    
    <vue-headful title="Subconscio.us / Street" />
    <div class="app-header">
    <div class="title">
      <h1>subconscio.us <span class="support">/ street</span> <span class="beta">beta</span></h1>
    </div>
    <div v-if="isAuthenticated">
    <Navbar />
    <User />
    <Alert />
    </div>
    <div class="content">
      <router-view/>
    </div>
  </div>
  </div>
 </v-app>
</template>

<script>
import Navbar from '@/components/nav/Navbar';
import User from '@/components/user/User';
import Alert from '@/components/system/Alert';
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  components: {
    Navbar,
    User,
    Alert
  },
  computed: {
    ...mapGetters(
        { isAuthenticated: 'auth/isAuthenticated' }
    ),
   },
  mounted() {
      if(Object.keys(this.$store.state.user.identity).length !== 0) {
          this.$ability.update(this.$store.state.user.identity.casl)
      }
  }
};
</script>

<style scoped lang="scss">
#app {
  font-family: 'Robot', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.beta {
  color: seagreen;
  vertical-align: super;
  font-size: 25%;
  padding-left: 10px;
}

.support {
  color: orange;
}

.content { margin-top: 60px;}

.title {
  position: absolute;
  top: 10px;

  h1 {
    font-size: 300%;
    padding-left: 10px;
  }
}

@media only screen and (max-width: 900px) {

    .app-header {
        padding-top: 0px;
    }

    .content {
      margin-top: 15px;
    }

    .title {
      font-size: 75%;
      position: relative;
      top: 0px;
      h1 {
        font-size: 175%;;
        padding-left: 10px;
        margin-top: 40px;
      }
    }
}

</style>

<style>
.v-application ul {
  padding: 0;
  margin: 0;
}
</style>
